import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFlux, cleanAloFlux } from '@/models/alo/AloFlux'
import { AloItemflux, cleanAloItemflux } from '@/models/alo/AloItemflux'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { AloCodicInfoTree } from '@/models/alo/AloCodicInfoTree'

export default {
  getInfosCodic(id:string): AxiosPromise<AlrContainer<AloCodicInfoTree>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/CodicInfo/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCodicInfoTree>  
      }]
    })
  },
  
}